<ion-header>
  <ion-toolbar class="thin-toolbar background-background" mode="ios">
    <frontend-header routeId="customers"></frontend-header>
  </ion-toolbar>
</ion-header>

<ion-content [forceOverscroll]="false">
  <frontend-pull-refresh></frontend-pull-refresh>

  <div class="search-row">
    <tablesready-search-bar
      #searchBarRef
      [placeholder]="'Search ' + settings?.displayOptions?.labels?.customer_plural || 'customers'"
      (search)="updateSearchText($event)"
    ></tablesready-search-bar>
  </div>

  <section *ngIf="totalCustomers; else message">
    <div class="actions-box">
      <div class="flex ml-2 mt-2">
        <button
          class="btn btn-info btn-icon flex mr-2"
          (click)="addSelectedToWaitlist()"
          [disabled]="bulkActionDisabled()"
        >
          <tr-icon [icon]="icon.addUser" [white]="true"></tr-icon>
          <span class="ml-2">Add selected to waitlist</span>
        </button>
        <button class="btn btn-danger btn-icon flex" (click)="deleteSelected()"
                [disabled]="bulkActionDisabled()">
          <tr-icon [icon]="icon.delete" [white]="true" classes="mr-2"></tr-icon>
          Delete selected
        </button>
      </div>

      <ngb-pagination
        class="mx-2 mt-2"
        [collectionSize]="totalCustomers"
        [pageSize]="perPage"
        [(page)]="page"
        [maxSize]="6"
        [ellipses]="true"
        (pageChange)="pageChange($event)"
      >
        <ng-template ngbPaginationPrevious>Previous</ng-template>
        <ng-template ngbPaginationNext>Next</ng-template>
      </ngb-pagination>
    </div>
    <table class="table table-striped tr-table">
      <thead>
      <tr>
        <th scope="col">
          <div class="dropdown show">
            <a class="dropdown-toggle" role="button" (click)="toggleDropDown()">
              Select
            </a>
            <div class="dropdown-menu" [class.show]="isOpenedMenu">
              <a class="dropdown-item" (click)="checkAll()">All</a>
              <a class="dropdown-item" (click)="unCheckAll()">None</a>
            </div>
          </div>
        </th>
        <th scope="col">
          <tablesready-sortable-column
            [sortBy]="customerListSortBy"
            column="name"
            title="name"
            [orderAscending]="reverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <th scope="col">
          <tablesready-sortable-column
            [sortBy]="customerListSortBy"
            column="phone"
            title="phone"
            [orderAscending]="reverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <th scope="col">
          <tablesready-sortable-column
            [sortBy]="customerListSortBy"
            column="totalVisits"
            title="visits"
            [orderAscending]="reverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <th scope="col">
          <tablesready-sortable-column
            [sortBy]="customerListSortBy"
            column="lastVisit"
            title="last visit"
            [orderAscending]="reverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <th scope="col">
          <tablesready-sortable-column
            [sortBy]="customerListSortBy"
            column="created_time"
            title="create time"
            [orderAscending]="reverse"
            (orderBy)="orderBy($event)"
          ></tablesready-sortable-column>
        </th>
        <th scope="col">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let customer of customers">
        <td>
          <div class="d-flex align-items-center">
            <span class="d-xs-inline pr-2 d-sm-none">Select: </span>
            <input type="checkbox" [(ngModel)]="customer.selected">
          </div>
        </td>
        <td>
          <span class="d-xs-inline d-sm-none">Name: </span>
          <button (click)="viewInfoCustomer(customer._id)"
                  class="btn btn-link">{{ customer.name }}</button>
        </td>
        <td>
          <span class="d-xs-inline d-sm-none">Phone: </span>
          ******{{ customer.phone | slice:-4 }}
        </td>
        <td>
          <span class="d-xs-inline d-sm-none">Total visits: </span>
          {{ customer.totalVisits }}
        </td>
        <td>
          <span class="d-xs-inline d-sm-none">Last visit: </span>
          {{ customer.lastVisit | trDateFormat:'M/D/yy h:mm a': timezone }}</td>
        <td>
          <span class="d-xs-inline d-sm-none">Created date: </span>
          {{ customer.created_time | trDateFormat:'M/D/yy h:mm a': timezone }}
        </td>
        <td>
          <div class="d-flex flex-nowrap mb-2">
            <button
              class="btn btn-success mr-2"
              data-toggle="tooltip" data-placement="top" title="Add to Waitlist"
              (click)="addToWaitlist(customer)"
              angularticsCategory="customer"
              angulartics2On="click"
              angularticsAction="Add to Waitlist">
              <tr-icon [icon]="icon.addUser" [white]="true"></tr-icon>
            </button>
            <button
              class="btn btn-info btn-icon mr-2 d-inline-block d-sm-none d-lg-inline-block"
              data-toggle="tooltip" data-placement="top"
              title="Edit"
              (click)="addEditCustomer(addEditCustomerMode.edit, customer._id)"
              angularticsCategory="customer"
              angulartics2On="click"
              angularticsAction="Edit Customer">
              <tr-icon [icon]="icon.edit" [white]="true"></tr-icon>
            </button>
            <button
              class="btn btn-danger btn-icon mr-2"
              data-toggle="tooltip" data-placement="top"
              title="Delete"
              (click)="deleteSelected(customer._id)"
              angularticsCategory="customer" angulartics2On="click"
              angularticsAction="Delete Customer">
              <tr-icon [icon]="icon.delete" [white]="true"></tr-icon>
            </button>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div class="col-12 d-flex justify-content-end">
      <ngb-pagination
        [collectionSize]="totalCustomers"
        [pageSize]="perPage"
        [(page)]="page"
        [rotate]="true"
        [maxSize]="6"
        (pageChange)="pageChange($event)"
      >
        <ng-template ngbPaginationPrevious>Previous</ng-template>
        <ng-template ngbPaginationNext>Next</ng-template>
      </ngb-pagination>
    </div>
  </section>

  <ng-template #message>
    <div class="bg-light p-3 rounded-0" role="alert">No customers</div>
  </ng-template>

  <section class="add-new">
    <button type="button" class="btn btn-accent btn-circle" (click)="addEditCustomer(addEditCustomerMode.add)">
      <tr-icon [icon]="icon.plus" [size]="size.extraLarge" [color]="color.white"></tr-icon>
    </button>
  </section>
</ion-content>
